import CuratenieShowRoomuri from "pages/Servicii/ServiciiSpeciale/CuratenieShowRoomuri";

export default function CuratenieShowRoomuriPage() {
    return <CuratenieShowRoomuri />;
}
